/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Price_LowerInputs */

const en_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating this booking will decrease its price. A credit note will be automatically generated and emailed to the visitor.`)
};

const de_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du diese Buchung aktualisierst, sinkt ihr Preis. Eine Gutschrift wird automatisch erstellt und dem Besucher per E-Mail zugesandt.`)
};

const es_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar esta reserva disminuirá su precio. Se generará automáticamente una nota de crédito y se enviará por correo electrónico al visitante.`)
};

const fr_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La modification de cette réservation diminuera son prix. Une note de crédit sera automatiquement générée et envoyée par e-mail au visiteur.`)
};

const it_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'aggiornamento di questa prenotazione ne diminuirà il prezzo. Una nota di credito verrà generata automaticamente e inviata via email al visitatore.`)
};

const pt_br2_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar esta reserva diminuirá seu preço. Uma nota de crédito será gerada automaticamente e enviada por e-mail ao visitante.`)
};

const pl_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualizacja tej rezerwacji zmniejszy jej cenę. Nota kredytowa zostanie automatycznie wygenerowana i wysłana e-mailem do gościa.`)
};

const hu_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A foglalás módosítása csökkenti az árát. Automatikusan jóváírási bizonylat készül, és e-mailben elküldésre kerül a látogatónak.`)
};

const ro_admin_external_booking_edit_price_lower = /** @type {(inputs: Admin_External_Booking_Edit_Price_LowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizarea acestei rezervări va scădea prețul. O notă de credit va fi generată automat și trimisă prin e-mail vizitatorului.`)
};

/**
* | output |
* | --- |
* | "Updating this booking will decrease its price. A credit note will be automatically generated and emailed to the visitor." |
*
* @param {Admin_External_Booking_Edit_Price_LowerInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_price_lower = /** @type {((inputs?: Admin_External_Booking_Edit_Price_LowerInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Price_LowerInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_price_lower(inputs)
	if (locale === "de") return de_admin_external_booking_edit_price_lower(inputs)
	if (locale === "es") return es_admin_external_booking_edit_price_lower(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_price_lower(inputs)
	if (locale === "it") return it_admin_external_booking_edit_price_lower(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_price_lower(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_price_lower(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_price_lower(inputs)
	return ro_admin_external_booking_edit_price_lower(inputs)
});
export { admin_external_booking_edit_price_lower as "admin.external_booking_edit.price_lower" }